var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Progress: "+_vm._s(Math.round(_vm.progress))+"%")]),_c('progress',{staticClass:"progress is-small is-primary",attrs:{"max":"100"},domProps:{"value":_vm.progress}})])}
var staticRenderFns = []

export { render, staticRenderFns }